import { BIBME, CHEGG, CITATION_MACHINE, EASYBIB } from '../site/types'
import { InteractionType } from './rsw/eventSchemas'

export const LOGGED_IN = 'hard_logged_in'

export const LOGGED_OUT = 'logged_out'

export const PAID_MEMBER = 'active'
export const NON_MEMBER = 'non_member'

export const FREEMIUM_PLAGIARISM = 'freemiumPlagiarism'
export const PAGE_TYPES = {
  // Actual navigation changes:
  PAPERS: 'my papers',
  EDITOR_GRAMMAR: 'editor grammar',
  EDITOR_PLAGIARISM: 'editor plagiarism',
  TERMS_AND_CONDITIONS: 'terms and conditions',
  PAPER_NOT_FOUND: 'paper not found',
  EC_FORM: 'expert check form',
  EC_FORM_TOO_LONG: 'expert check too long',
  EC_SUCCESS: 'expert check success submitted',
  EC_IN_PROGRESS: 'expert check waiting',
  EC_COMPLETE: 'expert check feedback',
  EC_UPGRADE: 'expert check value prop',
  PLANS: 'study pack offer interstitial',
  // Modals tagged as pseudo "pageview"s
  AUTH_MODAL: 'auth modal',
  UPSELL_MODAL: 'upsell modal',
  RESULTS_MODAL: 'your results modal',
  PAYWALL_MODAL: 'paywall modal',
  PAYMENT_CONFIRMATION_MODAL: 'payment confirmation modal',
  PLAGIARISM_SOURCES_MODAL: 'plagiarism sources modal',
  CHECK_FAILED_MODAL: 'check failed modal',
  PLAGIARISM_CHECK_MODAL: 'plagiarism check modal',
  PAPER_PROCESSING_MODAL: 'paper processing modal',
  PAPER_SCORECARD_MODAL: 'paper scorecard modal',
  // demo
  PAPER_SCORECARD_MODAL_DEMO: 'paper scorecard modal demo',
  EDITOR_GRAMMAR_DEMO: 'editor grammar demo',
  EDITOR_PLAGIARISM_DEMO: 'editor plagiarism demo',
  EC_DEMO: 'expert check demo',
  UPLOAD_WIDGET_MODAL: 'upload your paper widget',
  UPLOAD_WIDGET_RESUBMIT_MODAL: 'resubmit your paper widget',
} as const

export const CHECK_EVENT_TYPES = {
  start: 'checkStart',
  end: 'checkComplete',
  ready: 'ready',
} as const

export const CHECK_EVENT_NAMES = {
  PROCESSING: 'paper upload processing',
  PROCESSED: 'paper upload processed',
} as const

export const PAPER_UPLOAD_ID = 'paper_upload_id'

export const CLICKSTREAM_INTERACTION_TYPES: { [key: string]: InteractionType } = {
  ACCEPT: 'accept',
  REJECT: 'reject',
  READ: 'read',
} as const

export const CLICKSTREAM_EVENT_STATES = {
  SUCCESS: 'success',
  EC_SUBMIT: 'expertCheckSubmit',
} as const

export const CLICKSTREAM_SUCCESS_NAMES = {
  EC_SUBMITTED: 'expert check paper upload submitted',
}

export const CLICKSTREAM_CHECK_TYPES = {
  EXPERT_CHECK: 'expertCheck',
}

export const cardActionToInteractionTypeMap = {
  accepted: CLICKSTREAM_INTERACTION_TYPES.ACCEPT,
  rejected: CLICKSTREAM_INTERACTION_TYPES.REJECT,
  read: CLICKSTREAM_INTERACTION_TYPES.READ,
}

export const EVENT_TYPES = {
  CARD_ENGAGEMENT: 'card_engagement',
  CLICKSTREAM_INTERACTION: 'clickstream_interaction',
  CLICKSTREAM_NOTIFICATIONS: 'clickstream_notifications',
  CLICKSTREAM_VIEW: 'clickstream_view',
  CLICKSTREAM_COMPONENT_VIEW: 'clickstream_component_view',
  CLICKSTREAM_SIGN_IN_START: 'clickstream_sign_in_start',
  CLICKSTREAM_SIGN_IN_SUCCESS: 'clickstream_sign_in_success',
  CLICKSTREAM_SIGN_UP_START: 'clickstream_sign_up_start',
  CLICKSTREAM_SIGN_UP_SUCCESS: 'clickstream_sign_up_success',
  CLICKSTREAM_SUCCESS: 'clickstream_success',
  // Sending the `PAPER_READY` event as type:paperUpload will ensure it goes to the same DB index as
  // other paper activity, allowing us to better view it alongside all paper events.
  PAPER_READY: 'paper_upload',
  // Similarly, sending paper check events to paperUpload end point for data processing convenience
  PAPER_CHECK_START: 'paper_upload',
  PAPER_CHECK_END: 'paper_upload',
} as const

export const viewExperienceMap = {
  [EASYBIB]: 'eb',
  [BIBME]: 'bm',
  [CITATION_MACHINE]: 'cm',
  [CHEGG]: 'cw',
} as const



// WEBPACK FOOTER //
// ./src/state/analytics/constants.ts